export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/environments/environment.ts